import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Button,
  MenuItem,
  InputLabel,
  FormControl,
  TextField
} from "@mui/material";
import { GridColDef, ptBR } from "@mui/x-data-grid";
import React, { useContext, useEffect, useState, useMemo } from "react"
import useDebouncedPagedSearch from "../../../hooks/useDebouncedPagedSearch"
import pagedGet from "../../../services/pagedGet"
import {
  CampoSelect,
  CampoAutoComplete,
  Content,
  FormControlEspacado,
  InputLabelBranco,
  StyledDataGrid
} from "./styles"
import Cliente from './../../../interfaces/cliente';
import axios from '../../../services/withAxios';
import { AxiosResponse } from "axios";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { toReal } from "../../../utils/MaskMonetario";
import { GFLContext } from "../../../infra/GFLContext";
import { TypeAlertEnum } from "../../../utils/enum/typeAlertEnum";
import { FormaPagamentoEnum } from "../../../utils/enum/formaPagamentoEnum";
import obterDescricaoFormaPagamento from "../../../utils/enum/formaPagamentoDescricao";
import { DownloadVenda } from "../../../services/DownloadVenda";
import brLocale from 'date-fns/locale/pt-BR';
import { EsconderPorNivelAcesso, getUser } from "../../../services/auth";
import { NivelAcessoEnum } from "../../../utils/enum/nivelAcessoEnum";
import CurrencyInput from "../CurrencyInput";
import { NumberFormatValues } from "react-number-format";
import toIsoString from "../../../utils/FormatDate/formatDateToIso";
import { datadogLogs } from '@datadog/browser-logs'
import Vendedor from "../../../interfaces/vendedor";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const colunas: GridColDef[] = [
  {
    field: 'produtoNome',
    headerName: 'Produto',
    width: 250
  },
  {
    field: 'quantidade',
    headerName: 'Quantidade',
    flex: 1
  },
  {
    field: 'valor',
    headerName: 'Valor Total',
    flex: 1,
    valueGetter: (params: any) => {
      const total = params.row.produtoValor * params.row.quantidade;

      return toReal(total);
    }
  }
]

const clienteVazio: Cliente = { nome: '', email: '', telefone: '', cpf: '', observacao: '' }

const FinalizarCompraDialog: React.FC<(
  {
    aberto: boolean, 
    setAberto: React.Dispatch<React.SetStateAction<boolean>>
  })> =
  ({ aberto, setAberto }) => {
    const [dataVenda, setDataVenda] = useState<Date | null>(new Date())
    const [desconto, setDesconto] = useState<number>()
    const [formaDePagamento, setFormaDePagamento] = useState<FormaPagamentoEnum | string>('')
    const [valorTotal, setValorTotal] = useState<number>()
    const [clienteSelecionado, setClienteSelecionado] = useState<Cliente | null>(null)
    const [vendedorSelecionado, setVendedorSelecionado] = useState<Vendedor | null>(null)
    const [desabilitarBotaoConcluir, setDesabilitarBotaoConcluir] = useState<boolean>(false)

    const [descontoHighlight, setDescontoHighlight] = useState<boolean>(false)
    const [valorTotalHighlight, setValorTotalHighlight] = useState<boolean>(false)

    const contexto = useContext(GFLContext)
    const venda = contexto.venda

    const {
      setInputValue: setClienteInput,
      items: clientesEncontrados,
      loading: carregandoClientes,
    } = useDebouncedPagedSearch<Cliente>('/cliente', {
      pageSize: 20,
      delayMs: 400,
      fetchOnEmpty: true,
    })

    const {
      setInputValue: setVendedorInput,
      items: vendedoresEncontrados,
      loading: carregandoVendedores,
    } = useDebouncedPagedSearch<Vendedor>('/vendedor', {
      pageSize: 20,
      delayMs: 400,
      fetchOnEmpty: true,
    })

    const clienteOptions = useMemo(() => {
      if (!clienteSelecionado) return clientesEncontrados
      if (clientesEncontrados.some(c => c.id === clienteSelecionado.id)) return clientesEncontrados
      return [clienteSelecionado, ...clientesEncontrados]
    }, [clientesEncontrados, clienteSelecionado])

    const vendedorOptions = useMemo(() => {
      if (!vendedorSelecionado) return vendedoresEncontrados
      if (vendedoresEncontrados.some(v => v.id === vendedorSelecionado.id)) return vendedoresEncontrados
      return [vendedorSelecionado, ...vendedoresEncontrados]
    }, [vendedoresEncontrados, vendedorSelecionado])

    useEffect(() => {
      if (aberto) {
        setValorTotal(totalVenda)
      }

    }, [aberto])



    useEffect(() => {
      selecionarVendedorPeloUsuarioLogado()
    }, [])

    useEffect(() => {

      if (descontoHighlight)
        setTimeout(() => {
          setDescontoHighlight(false)
        }, 1000)

      if (valorTotalHighlight)
        setTimeout(() => {
          setValorTotalHighlight(false)
        }, 1000)

    }, [descontoHighlight, valorTotalHighlight])

    const handleClose = () => {
      if (formaDePagamento === '') {
        mensagemValidacao("É necessário informar a forma de pagamento para concluir a venda!")
        return
      }

      setDesabilitarBotaoConcluir(true)
      const novaVenda = {
        itens: venda.itens,
        clienteId: clienteSelecionado?.id ?? null,
        valorDesconto: desconto,
        formaPagamento: formaDePagamento,
        data: toIsoString(dataVenda),
        vendedorId: vendedorSelecionado?.id ?? null
      };

      axios.post('/venda', novaVenda).then((e: AxiosResponse) => {
        // datadogLogs.logger.info('Venda efetuada', { venda: { ...novaVenda }, axiosResponse: e })

        if (e.status === 200) {
          setAberto(false)
          venda.setItens([])
        }

      }).finally(() => {
        setDesabilitarBotaoConcluir(false)
      })
    }

    const validarParaBaixarResumo = () => {
      return (formaDePagamento !== '' && clienteSelecionado !== null)
    }

    const ativarHighlightDesconto = () => {
      setDescontoHighlight(true)
    }

    const ativarHighlightValorTotal = () => {
      setValorTotalHighlight(true)
    }

    const mensagemValidacao = (mensagem: string, type?: TypeAlertEnum) => {
      contexto.setMessageAlert(mensagem)
      contexto.setTypeAlert(type ? type : TypeAlertEnum.warning)
      contexto.setOpenAlert(true)
    }

    const handleDownloadVenda = () => {
      if (!validarParaBaixarResumo()) {
        mensagemValidacao("É necessário preencher a forma de pagamento e o cliente para imprimir o resumo de venda.")
        return
      }

      const cliente = clienteSelecionado ?? clienteVazio
      const formaDePagamentoPdf = formaDePagamento === '' ? FormaPagamentoEnum.credito : formaDePagamento

      try {
        DownloadVenda({ vendaItens: venda.itens, cliente, formaPagamento: formaDePagamentoPdf, valorTotal: totalVenda, dataVenda: dataVenda ?? new Date(), desconto: desconto ? desconto : 0 })
      } catch (e: any) {
        mensagemValidacao(`Houve um problema ao imprimir a venda. Log:${e.message}`, TypeAlertEnum.error);
      }
    }

    const calcularTotal = () => {
      const total = venda.itens.reduce((total, item) => {
        return total + (item.produtoValor * item.quantidade)
      }, 0)

      return total
    }

    const totalVenda = useMemo(() => calcularTotal(), [venda.itens])

    const selecionarVendedorPeloUsuarioLogado = async () => {
      const { unique_name } = getUser()
      if (!unique_name)
        return

      const result = await pagedGet<Vendedor>('/vendedor', {
        page: 1,
        pageSize: 20,
        pesquisa: unique_name,
        params: { avoidLoadingScreen: true },
      })

      const vendedorLogado = result.items.find(vendedor => vendedor.usuarioLogin === unique_name)
      if (vendedorLogado)
        setVendedorSelecionado(vendedorLogado)
    }

    const handleValorTotalChange = (v: NumberFormatValues) => {
      if (!v.floatValue) {
        setValorTotal(0)
        setDesconto(totalVenda)
        ativarHighlightDesconto()
        return
      }

      if (v.floatValue > totalVenda) {
        mensagemValidacao(`O valor total da venda não pode ser maior que o valor original de ${toReal(totalVenda)}`)
        ativarHighlightValorTotal()
        setValorTotal(totalVenda)
        setDesconto(0)
      } else {
        setValorTotal(v.floatValue)
        setDesconto(totalVenda - v.floatValue)
      }
      ativarHighlightDesconto()
    }

    const handleDescontoChange = (v: NumberFormatValues) => {
      if (v.floatValue === undefined || v.floatValue === null) {
        setDesconto(0)

        return
      }

      if (v.floatValue > totalVenda) {
        mensagemValidacao(`O desconto não pode ser maior que o valor da venda de ${toReal(totalVenda)}`)
        setDesconto(0)
        setValorTotal(totalVenda)
      } else {
        setDesconto(v.floatValue)
        setValorTotal(totalVenda - v.floatValue)
      }

      ativarHighlightValorTotal()
    }

    return (
      <>
        <Dialog
          open={aberto}
          onClose={() => setAberto(false)}
          fullScreen={useMediaQuery("(max-width: 1024px)")}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Finalizar Venda</DialogTitle>
          <DialogContent>
            <Content>
              {venda.itens.length > 0 ?
                <StyledDataGrid
                  localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                  columns={colunas}
                  rows={venda.itens}
                  disableColumnMenu={true}
                  hideFooter={true}
                  getRowId={(row: any) => row.produtoId}
                /> : null}
            </Content>
            <EsconderPorNivelAcesso nivelAcesso={[NivelAcessoEnum.admin, NivelAcessoEnum.gerente]}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={brLocale}>
                  <DatePicker
                    label="Data da venda"
                    value={dataVenda}
                    inputFormat="dd/MM/yyyy"
                    onChange={(novaData) => {
                      setDataVenda(novaData);
                    }}
                    renderInput={(params) => <TextField style={{ margin: "1vh 0 1vh 0" }}  {...params} />}
                  />
                </LocalizationProvider>
              </FormControl>
            </EsconderPorNivelAcesso>
            <FormControl fullWidth>
              <FormControlEspacado focused variant='outlined' fullWidth>
                <InputLabelBranco>Desconto</InputLabelBranco>
                <CurrencyInput
                  onValueChange={handleDescontoChange}
                  value={desconto}
                  color={valorTotalHighlight ? 'warning' : undefined}
                  required
                  autoComplete='off'
                  maxLength={20}
                />
              </FormControlEspacado>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel id="formaDePagamentoId">Forma de Pagamento</InputLabel>
              <CampoSelect
                labelId="formaDePagamentoId"
                id="formaDePagamentoId"
                value={formaDePagamento}
                required
                inputProps={{ style: { textTransform: "uppercase" } }}
                onChange={(e) => setFormaDePagamento(e.target.value as FormaPagamentoEnum)}
                renderValue={(value) => value !== null ? obterDescricaoFormaPagamento(value as FormaPagamentoEnum) : "Selecionar..."}
              >
                <MenuItem disabled>Forma de Pagamento</MenuItem>
                <MenuItem value={FormaPagamentoEnum.debito}>Débito</MenuItem>
                <MenuItem value={FormaPagamentoEnum.credito}>Crédito</MenuItem>
                <MenuItem value={FormaPagamentoEnum.pix}>Pix</MenuItem>
                <MenuItem value={FormaPagamentoEnum.dinheiro}>Dinheiro</MenuItem>
              </CampoSelect>
            </FormControl>
            <FormControl fullWidth>
              <CampoAutoComplete
                id="clienteId"
                options={clienteOptions}
                value={clienteSelecionado}
                loading={carregandoClientes}
                autoComplete={true}
                filterOptions={(options) => options}
                isOptionEqualToValue={(option: Cliente, value: Cliente) => option.id === value.id}
                getOptionLabel={(option: Cliente) => option?.nome ?? ''}
                clearText="Limpar"
                closeText="Fechar"
                openText="Abrir"
                loadingText="Buscando..."
                noOptionsText="Nenhuma opção encontrada"
                onInputChange={(_: any, value: string, reason: string) => {
                  if (reason === 'input' || reason === 'clear')
                    setClienteInput(value)
                }}
                onChange={(_: any, clienteOption: Cliente | null) => setClienteSelecionado(clienteOption)}
                renderInput={(params) => <TextField {...params} label="Cliente" />}
              />
            </FormControl>
            <FormControl fullWidth>
              <CampoAutoComplete
                id="vendedorId"
                options={vendedorOptions}
                value={vendedorSelecionado}
                loading={carregandoVendedores}
                autoComplete={true}
                filterOptions={(options) => options}
                isOptionEqualToValue={(option: Vendedor, value: Vendedor) => option.id === value.id}
                getOptionLabel={(option: Vendedor) => option?.nome?.toUpperCase() ?? ''}
                clearText="Limpar"
                closeText="Fechar"
                openText="Abrir"
                loadingText="Buscando..."
                noOptionsText="Nenhuma opção encontrada"
                onInputChange={(_: any, value: string, reason: string) => {
                  if (reason === 'input' || reason === 'clear')
                    setVendedorInput(value)
                }}
                onChange={(_: any, vendedorOption: Vendedor | null) => setVendedorSelecionado(vendedorOption)}
                renderInput={(params) => <TextField {...params} label="Vendedor" />}
              />
            </FormControl>
            <FormControl fullWidth>
              <FormControlEspacado focused variant='outlined' fullWidth>
                <InputLabelBranco>Valor Total</InputLabelBranco>
                <CurrencyInput
                  onValueChange={handleValorTotalChange}
                  value={valorTotal}
                  required
                  color={valorTotalHighlight ? 'warning' : undefined}
                  autoComplete='off'
                  maxLength={20}
                />
              </FormControlEspacado>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button color="secondary" onClick={() => setAberto(false)}>Fechar</Button>
            <Button color="secondary" onClick={handleDownloadVenda}>Baixar Resumo da Venda</Button>
            <Button onClick={handleClose} disabled={desabilitarBotaoConcluir}>Concluir</Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }

export default FinalizarCompraDialog